<template>
    <b-modal
      id="mainRegistration"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg"
      centered
    >

  <!-- <b-modal hide-footer centered v-model="isVisible"> -->
    <section class="text-center">
      <b-row no-gutters class="justify-content-center">
        <b-col cols="12" class="py-2">
          <h3 class="font-weight-bold">הרשמה</h3>
          <b-link @click="goToTermsOfUse">
            <small>
            על ידי המשך התהליך
            <u>אני מסכים לתנאי </u> 
            <u>השימוש ולמדיניות הפרטיות של האתר </u>
          </small>
          </b-link>
        </b-col>
        <b-col cols="8" class="py-2">
          <b-btn 
            pill
            variant="outline-info"
            block
            class="py-2"
            @click="loginToAppWithGoogle"
            >
            Google <span class="text-dark">הרשמה באמצעות</span></b-btn
          >
        </b-col>
        <!-- <b-col cols="8" class="py-2">
          <b-btn pill variant="outline-info" block class="py-2">
            Facebook <span class="text-dark">הרשמה באמצעות</span></b-btn
          >
        </b-col> -->
        <b-col cols="8" class="py-2"> ֹאו </b-col>
        <b-col cols="8" class="py-2">
            <div class="mt-3">
              <b-input-group class="mt-3 shadow">
                <b-form-input
                  @input="updateUserName"
                  placeholder="שם משתמש"
                  class="border-0 text-right"
                  type="text"
                ></b-form-input>
              </b-input-group>
            </div>
            <div class="mt-3">
              <b-input-group class="mt-3 shadow">
              <b-form-input
                :value="email"
                @input="updateEmail"
                id="email"
                placeholder="מייל"
                class="border-0 shadow text-right"
                required
              ></b-form-input>
              </b-input-group>
            </div>
            <div class="mt-3">
              <b-input-group class="mt-3 shadow">
                <b-form-input
                  :value="password"
                  @input="updatePassword"
                  placeholder="סיסמא"
                  class="border-0 text-right"
                  type="password"
                ></b-form-input>
              </b-input-group>
            </div>
            <div class="mt-3">
              <b-input-group class="mt-3 shadow">
                <b-form-input
                  :value="rePassword"
                  @input="updateRePassword"
                  placeholder="סיסמא פעם נוספת"
                  class="border-0 text-right"
                  type="password"
                ></b-form-input>
              </b-input-group>
            </div>
          <p></p>
          <div class="mt-3 text-right rtl">
            <label for="remember-me" class="mr-3">
          <b-link @click="goToTermsOfUse">

              <span class="turquoise"> קראתי</span>
          </b-link>
              את התקנון
            </label>
            <b-form-checkbox
              style="display: inline-block"
              id="remember-me"
              class="mb-2 mr-sm-2 mb-sm-0"
            ></b-form-checkbox>
          </div>

          <b-btn
            pill
            variant="warning"
            block
            class="py-2"
            @click="newUserRegistration"
          >
            הרשמה באמצעות המייל</b-btn
          >
        </b-col>
      </b-row>
    </section>
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: ["value"],
  computed: {
     ...mapGetters([  'email',
                      'password',
                      'rePassword',
                      'userName',
                      'isNewUser']),
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: 
  {
    ...mapActions(['register',
                   'authenticate',
                   'registerNewUser',
                   'validateAndupdateAppToken',
                   'goToTermsOfUse',
                   'loginToAppWithGoogle',
                   ]),
    newUserRegistration () {
      const password  = this.password;
      const rePassword  = this.rePassword;
      if( password != rePassword ){ 
        this.$store.commit('setRePassword', '');
        this.$store.commit('setPassword', '');
        return;
      }
      this.$store.dispatch('registerNewUser');
      this.$store.dispatch( 'showModal', "" );
    },   
    updateEmail (value) {
      this.$store.commit('setEmail', value)
    },
    updateUserName (value) {
      this.$store.commit('setUserName', value)
    },
    updatePassword (value) {
      this.$store.commit('setPassword', value)
    },
    updateRePassword (value) {
      this.$store.commit('setRePassword', value)
    },
  },

};
</script>
<style>
</style>